module.exports = __webpack_public_path__ + "static/media/GothamBook.eca1317e.otf";